module.exports = __webpack_public_path__ + "static/media/conteinerCopro.773ce654.png";